import type * as THREE from 'three'
import { Y_TAMPA_TRASEIRA_BAIXA, type PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import { vetor, type Vetor3 } from '../../dominio/geometria/vetor3'
import { orientacaoEntre, pontoMedio } from '../componentes/Barra'
import { criarCaixaArredondada, geometriaBase, type TransformacaoRepouso } from './malhaDeformavel'

/**
 * Traseira deformável.
 *
 * O campo da traseira (`deslocamentoLongitudinal` com sentido −1) não é a
 * frente espelhada: o para-choque SOBE (quem bate mergulha por baixo), a tampa
 * entra pela borda de baixo e dobra em dois vincos, as lanternas se deslocam e
 * o piso do porta-malas levanta no severo. Aqui fica a base da tampa.
 */

/** Pontos de articulação e de fechamento da tampa (as mesmas contas da Carroceria). */
export function extremosTampaTraseira(perfil: PerfilVeiculo): { de: Vetor3; para: Vetor3 } {
  const hatch = perfil.volumeTraseiro === 'hatch'
  return {
    de: hatch
      ? vetor(0, perfil.cinturaY - 0.04, perfil.colunaC.zBase - 0.02)
      : vetor(0, perfil.cinturaY, perfil.colunaC.zBase - 0.02),
    para: hatch
      ? vetor(0, Y_TAMPA_TRASEIRA_BAIXA, perfil.traseiraZ + 0.04)
      : vetor(0, perfil.cinturaY + 0.02, perfil.traseiraZ + 0.05),
  }
}

export function baseTampaTraseira(perfil: PerfilVeiculo, largura: number, espessura: number): THREE.BufferGeometry {
  const { de, para } = extremosTampaTraseira(perfil)
  const altura = Math.hypot(para.y - de.y, para.z - de.z)
  return geometriaBase(`tampaTraseira:${perfil.id}:${largura.toFixed(3)}`, () =>
    criarCaixaArredondada(largura, altura, espessura, [16, 12, 1], 0.01),
  )
}

/** Pose do painel inclinado entre `de` e `para` (+Y local ao longo do painel). */
export function repousoPainelInclinado(de: Vetor3, para: Vetor3): TransformacaoRepouso {
  const centro = pontoMedio(de, para)
  return { posicao: [centro.x, centro.y, centro.z], quaternion: orientacaoEntre(de, para) }
}
